// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__Q4OdQ","inner":"NotFound_inner__JNSx7","notFoundImg":"NotFound_notFoundImg__0TsuH"};